import {handleGqlResponseBody} from '@/utils/apollo.util';
import {GET_BLOG_PAGINATED_QUERY} from '@/graphql/store/blog/blog.query';

const blog = {
	actions: {
		async getBlogsPaginatedQuery({commit}, {skip, take, orderBy, query, public: isPublic}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_BLOG_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query,
						public: isPublic
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
	}
};

export default blog;
